export interface BuildingAdminMacro {
  buildingId: string;
  buildingName: string;
  macrocommunity?: boolean;
}

export interface BuildingQueryParams {
  all: string;
  buildingId?: string;
}

export interface BuildingResponseRequest {
  data: {
    buildings: BuildingResponsePaginated;
  };
}

export interface ResponsePaginated {
  docs?: any;
  totalDocs: number;
  limit: number;
  page: number;
  totalPages: number;
  nextPage: number;
  prevPage: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
}

export interface BuildingResponsePaginated extends ResponsePaginated {
  docs: BuildingAdminMacro[];
}

export enum CommunitiesType {
  macrocommunity = 'macrocommunity',
  community = 'community',
}
